import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState: any = {
loading: false,
schedulerList: [],
totalCount: 0,
currentPage: 1,
pageSize: 10,
filter: null,
reset: false
};

const slice = createSlice({
name: 'Schedulers',
initialState,
reducers: {
    setSchedulers: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.schedulerList = payload || [];
      state.reset = false;
    },
    setTotalCount: (state, { payload }: PayloadAction<any>) => {
      state.totalCount = payload;
    },
    setCurrentPage: (state, { payload }: PayloadAction<any>) => {
      state.currentPage = payload;
    },
    setPageSize: (state, { payload }: PayloadAction<any>) => {
      state.pageSize = payload;
    },
    setFilter: (state, { payload }: PayloadAction<any>) => {
      state.filter = payload;
    },
    reset: (state) => {
      state.reset = true;
    }
  }
});

export const { setSchedulers, setTotalCount, setCurrentPage, setPageSize, setFilter, reset } = slice.actions;

export default slice.reducer;